import React from "react";

const Shimmer = ({ width, height = 14, radius = 8 }) => (
  <span className="sy-flow-shimmer fin-shimmer" style={{ width, height, borderRadius: radius }} />
);

export const WalletCardSkeleton = () => (
  <div className="fin-wallet fin-wallet-skeleton">
    <Shimmer width="38%" height={12} />
    <Shimmer width="62%" height={34} radius={12} />

    <div className="fin-wallet-actions">
      <Shimmer width={140} height={44} radius={999} />
      <Shimmer width={140} height={44} radius={999} />
    </div>
  </div>
);

export const RecipientCardsSkeleton = ({ cards = 2 }) => (
  <div className="fin-accounts-rail">
    {Array.from({ length: cards }).map((_, index) => (
      <div className="fin-account fin-account-skeleton" key={index}>
        <Shimmer width="60%" height={12} />
        <Shimmer width="80%" height={18} />
        <Shimmer width="45%" height={12} />
      </div>
    ))}
  </div>
);

export const TransactionRowsSkeleton = ({ rows = 5 }) => (
  <ul className="fin-rows">
    {Array.from({ length: rows }).map((_, index) => (
      <li className="fin-row fin-row-skeleton" key={index}>
        <Shimmer width={42} height={42} radius={14} />

        <div className="fin-row-body">
          <Shimmer width="52%" height={14} />
          <Shimmer width="34%" height={12} />
        </div>

        <div className="fin-row-tail">
          <Shimmer width={92} height={14} />
          <Shimmer width={64} height={12} />
        </div>
      </li>
    ))}
  </ul>
);

export const TransactionTableSkeleton = ({ rows = 5 }) => (
  <div className="fin-table-wrap">
    <table className="fin-table">
      <thead>
        <tr>
          <th>Transaction</th>
          <th>Method</th>
          <th>Date</th>
          <th className="fin-table-amount-col">Amount</th>
        </tr>
      </thead>

      <tbody>
        {Array.from({ length: rows }).map((_, index) => (
          <tr key={index}>
            <td>
              <span className="fin-table-title">
                <Shimmer width={36} height={36} radius={12} />
                <Shimmer width={130} height={14} />
              </span>
            </td>

            <td>
              <Shimmer width={80} height={13} />
            </td>

            <td>
              <Shimmer width={90} height={13} />
            </td>

            <td className="fin-table-amount-col">
              <Shimmer width={70} height={14} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const SummaryLinesSkeleton = ({ lines = 3 }) => (
  <div className="fin-summary-skeleton">
    {Array.from({ length: lines }).map((_, index) => (
      <div className="fin-summary-line" key={index}>
        <Shimmer width="34%" height={13} />
        <Shimmer width="26%" height={13} />
      </div>
    ))}
  </div>
);

export const FinancePageSkeleton = () => (
  <>
    <div className="fin-top-grid">
      <WalletCardSkeleton />

      <section className="sy-flow-card">
        <div className="sy-flow-card-head">
          <h2 className="sy-flow-card-title">Withdrawal Accounts</h2>
        </div>

        <div className="sy-flow-card-body">
          <RecipientCardsSkeleton />
        </div>
      </section>
    </div>

    <section className="sy-flow-card">
      <div className="sy-flow-card-head">
        <h2 className="sy-flow-card-title">Transaction History</h2>
      </div>

      <div className="sy-flow-card-body">
        <TransactionTableSkeleton />
      </div>
    </section>
  </>
);
